module.exports = __webpack_public_path__ + "img/Virtual Estimate 2.svg";